import { configureStore } from "@reduxjs/toolkit";

import generalsSlice from "./generals/slice";

import loginSlice from "./login/slice";
import planSlice from "./plan/slice";
import signUpSlice from "./signUp/slice";
import paymentSlice from "./payment/slice";
import invoiceSlice from "./invoice/slice";
import createVSSlice from "./createVirtualSpace/slice";
import myAccountSlice from "./myAccount/slice";
import mySubscriptionsSlice from "./mySubscriptions/slice";
import mySubscriptionSlice from "./mySubscription/slice";
import billingActivitySlice from "./billingActivity/slice";
import virtualSpacesSlice from "./virtualSpaces/slice";
import chanceSubscriptionSlice from "./changeSubscription/slice";
import activateAccounSlice from "./activateAccount/slice";
import forgotPasswordSlice from "./forgotPassword/slice";
import resetPasswordSlice from "./resetPassword/slice";

export const store = configureStore({
  reducer: {
    generals: generalsSlice,
    login: loginSlice,
    plan: planSlice,
    signUp: signUpSlice,
    payment: paymentSlice,
    invoice: invoiceSlice,
    createVirtualSpace: createVSSlice,
    myAccount: myAccountSlice,
    mySubscriptions: mySubscriptionsSlice,
    mySubscription: mySubscriptionSlice,
    billingActivity: billingActivitySlice,
    virtualSpaces: virtualSpacesSlice,
    changeSubscription: chanceSubscriptionSlice,
    activateAccount: activateAccounSlice,
    forgotPassword: forgotPasswordSlice,
    resetPassword: resetPasswordSlice
  },
  //middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(getCustomerByEmail),
});

export default store;




